<script>
import store from '@state/store'

export default {
  watch: {
    invites: {
      handler(val) {
        if (!this.errorFlag) {
          return
        }
        val.forEach((item) => {
          if (item.name || item.email) {
            this.errorFlag = false
          }
        })
      },
      deep: true,
    },
  },
  methods: {
    inviteUser() {
      this.invites.push({ name: '', email: '' })
    },
    addNewUsers(callback) {
      const invitesArr = []
      this.invites.forEach((item) => {
        if (item.name || item.email) {
          invitesArr.push(item)
        }
      })
      if (!invitesArr.length) {
        this.errorFlag = true
        return
      }
      const params = { invites: JSON.stringify(invitesArr) }
      store
        .dispatch('adminUsers/addNewUsersToCompany', {
          companyId: this.companyId,
          params,
        })
        .then(() => {
          this.invites = this.invitesDefault
          this.errorFlag = false
          alert('Users have been successfully invited!')
          if (typeof callback === 'function') {
            callback()
          }
        })
        .catch((err) => {
          alert(err.message || 'Something went wrong.')
        })
    },
  },
}
</script>
